module.exports = __webpack_public_path__ + "static/media/01_AIANewYork_Logo_Black.e2a85ffc.png";